import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { EConnectionType } from '../const';
import { setConnectionState } from '../store/connectionSlice';

interface IUseUpdateConnectionState {
  type: EConnectionType;
  isConnected: boolean;
  accountAddress: string | null;
  walletIcon: string | null;
  chainId: number | null;
  connectionKey?: string;
  disconnect: () => Promise<void>;
}

export function useUpdateConnectionState({
  type: selectedType,
  isConnected,
  accountAddress,
  chainId,
  disconnect,
  walletIcon,
}: IUseUpdateConnectionState): void {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      setConnectionState({
        type: selectedType,
        isConnected,
        accountAddress,
        chainId,
        disconnect,
        walletIcon,
      }),
    );
  }, [
    accountAddress,
    chainId,
    disconnect,
    dispatch,
    isConnected,
    selectedType,
    walletIcon,
  ]);
}
